import { Component, Event, EventEmitter, h, Prop, State } from '@stencil/core'
import { classes } from 'src/utils/css'

import { CallStore } from '../state'

@Component({
  tag: 'page-call-detail-ask-fathom-form',
})
export class PageCallDetailAskForm {
  @Event({ bubbles: false }) submittedMessage: EventEmitter<string>

  @Prop() isNextMessageLoading: boolean

  @State() inputValue: string

  render() {
    const isCallProcessing = !!CallStore.state.call.processing_duration
    const isButtonDisabled = !this.inputValue || this.isNextMessageLoading || isCallProcessing

    return (
      <form
        onSubmit={(e: Event) => {
          e.preventDefault()
          this.submittedMessage.emit(this.inputValue)
          this.inputValue = ''
        }}
      >
        <ui-input
          type='text'
          name='message'
          placeholder='Ask Fathom AI'
          disabled={this.isNextMessageLoading || isCallProcessing}
          required
          value={this.inputValue}
          onInput={(event: globalThis.Event) => {
            const inputValue = (event.target as HTMLInputElement).value
            this.inputValue = inputValue
          }}
        />
        <button
          type='submit'
          class={`flex absolute right-26px bottom-26px justify-center items-center px-2 h-6 text-md text-black bg-brand hover:bg-opacity-80 rounded-base border border-transparent transition-colors 
            ${classes(isButtonDisabled, 'pointer-events-none opacity-50')}
          `}
          disabled={isButtonDisabled}
        >
          <ui-icon icon='arrow-up' />
        </button>
        {isCallProcessing && (
          <ui-infotip contentWidth='60'>
            Give me a few more seconds, Fathom is still completing the transcription of your meeting
          </ui-infotip>
        )}
      </form>
    )
  }
}
